
const apiurl="https://0cchspun42.execute-api.us-east-1.amazonaws.com/prod/";

export default apiurl;
